import React, {ReactElement} from 'react';
import {styled} from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';

/**
 * 라디오 버튼 컴포넌트의 Props 인터페이스
 * @property {ReactElement} [children] - 자식 요소
 * @property {boolean} checked - 선택 여부
 * @property {() => void} onChange - 변경 이벤트 핸들러
 * @property {React.CSSProperties} [containerStyle] - 컨테이너 스타일
 * @property {React.CSSProperties} [radioStyle] - 라디오 버튼 스타일
 * @property {string} [value] - 값
 */
interface IRadioButton {
  children?: ReactElement;
  checked: boolean;
  onChange: () => void;
  containerStyle?: React.CSSProperties;
  radioStyle?: React.CSSProperties;
  value?: string;
}

/**
 * 라디오 버튼 컴포넌트
 * 라디오 버튼을 표시하는 컴포넌트입니다.
 * @param {IRadioButton} props - 라디오 버튼 컴포넌트의 props
 * @returns {JSX.Element} 라디오 버튼 컴포넌트
 */
const RadioButton = ({
  children,
  checked,
  onChange,
  containerStyle,
  radioStyle,
  value,
}: IRadioButton) => {
  return (
    <Container style={containerStyle}>
      <Radio
        style={radioStyle}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {children}
    </Container>
  );
};

const Container = styled.label`
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  cursor: pointer;
`;

const Radio = styled.input`
  width: ${minmax(30)};
  height: ${minmax(30)};
  /* margin-right: 8px; */
  cursor: pointer;
  appearance: none;

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    display: inline-block;
    background-image: url('images/common/radio_check_off.png');
    background-repeat: no-repeat;
    background-size: contain;
  }

  &:checked::after {
    background-image: url('images/common/radio_check_on.png');
  }
`;

export default RadioButton;
